<template>
  <table class="table table-nowrap mb-0">
    <tbody>
    <tr>
      <th scope="row">First Name :</th>
      <td>
        {{userDetails.firstName}}
      </td>
    </tr>
    <tr>
      <th scope="row">Last Name :</th>
      <td>
        {{userDetails.lastName}}
      </td>
    </tr>
    <tr>
      <th scope="row">Phone Number :</th>
      <td>
        {{userDetails.phoneNumber}}
      </td>
    </tr>
    <tr>
      <th scope="row">E-mail :</th>
      <td>
        {{userDetails.email}}
      </td>
    </tr>
    <tr>
      <th scope="row">ID Number :</th>
      <td>
        {{userDetails.profile.idNumber}}
      </td>
    </tr>
    <tr>
      <th scope="row">KRA Pin :</th>
      <td>{{userDetails.profile.kraPin}}</td>
    </tr>
    <tr>
      <th scope="row">NHIF :</th>
      <td>{{userDetails.profile.nhif}}</td>
    </tr>
    <tr>
      <th scope="row">NSSF :</th>
      <td>{{userDetails.profile.nssf}}</td>
    </tr>
    <tr>
      <th scope="row">Physical Address :</th>
      <td>{{userDetails.profile.physicalAddress}}</td>
    </tr>
    <tr>
      <th scope="row">P.O Box :</th>
      <td>{{userDetails.profile.poBox}}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
name: "profile-update-component",
  data(){
    return{

    }
  },
  props:{
    userDetails: {
      type: Object,
      default (){
        return {
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
          profile: {
            idNumber: "",
            kraPin: "",
            nhif: "",
            nssf: "",
            physicalAddress: "",
            poBox: "",
          }
        }
      }
    }
  },
}
</script>

<style scoped>

</style>
